import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

/**
 * All query parameters used by the app.
 *
 * These are URL query-string values (e.g. `?scenario=sandbox`) that represent
 * UI state or routing context that should survive refreshes and deep links.
 */
export enum QueryParam {
  /** Alias of the selected scenario for the current app context. */
  ScenarioAlias = 'scenario',
}
// Needs to be before namespace is defined
const QUERY_PARAMS: ReadonlySet<QueryParam> = new Set(
  Object.values(QueryParam) as QueryParam[],
)
export namespace QueryParam {
  export const ALL: readonly QueryParam[] = Array.from(QUERY_PARAMS)
  export const isQueryParam = TypeChecker.Factory.oneOf(QUERY_PARAMS)
  export const assertIsQueryParam: TypeAsserter<QueryParam> =
    TypeAsserter.Factory.from(isQueryParam)
}
